import React from 'react';
import { UsersIcon } from 'lucide-react';
export const CivilRegistryWidget = () => {
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 h-full" data-id="element-1941">
      <div className="px-6 py-4 border-b border-gray-200" data-id="element-1942">
        <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-1943">
          <UsersIcon className="h-5 w-5 text-indigo-500 mr-2" data-id="element-1944" />
          Civil Registry
        </h2>
      </div>
      <div className="p-6" data-id="element-1945">
        <div className="flex flex-col space-y-4" data-id="element-1946">
          <div className="flex justify-between items-center" data-id="element-1947">
            <span className="text-sm text-gray-600" data-id="element-1948">
              Birth Registration Requests
            </span>
            <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-1949">
              12
            </span>
          </div>
          <div className="flex justify-between items-center" data-id="element-1950">
            <span className="text-sm text-gray-600" data-id="element-1951">
              Marriage License Applications
            </span>
            <span className="bg-pink-100 text-pink-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-1952">
              8
            </span>
          </div>
          <div className="flex justify-between items-center" data-id="element-1953">
            <span className="text-sm text-gray-600" data-id="element-1954">
              Residency Certificate Requests
            </span>
            <span className="bg-purple-100 text-purple-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-1955">
              5
            </span>
          </div>
          <div className="mt-4 bg-gray-100 rounded-lg p-3" data-id="element-1956">
            <p className="text-xs text-gray-700 font-medium" data-id="element-1957">
              This Week's Statistics
            </p>
            <div className="mt-2 text-xs text-gray-600" data-id="element-1958">
              <p data-id="element-1959">• 42 Records Processed</p>
              <p data-id="element-1960">• 18 Certificates Issued</p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex border-t border-gray-200 divide-x divide-gray-200" data-id="element-1961">
        <a href="#" className="flex-1 px-4 py-3 text-sm font-medium text-blue-600 hover:text-blue-800 text-center" data-id="element-1962">
          Process Vital Records
        </a>
        <a href="#" className="flex-1 px-4 py-3 text-sm font-medium text-blue-600 hover:text-blue-800 text-center" data-id="element-1963">
          Issue Residency Certs
        </a>
      </div>
    </div>;
};